module.exports = __webpack_public_path__ + "img/calendar-11.2dae0ba5.png";